



















import { Component, Vue } from 'vue-property-decorator'
import { getChoiceCMS, getChoiceList, PromotionCMSResponse } from './promotion-service'
import PromotionChoiceItem from './components/promotion_choice_item.vue'
import { setShareInfo } from '@utils/index'

@Component({
  components: {
    PromotionChoiceItem,
  },
})
export default class Choice extends Vue {
  config: PromotionCMSResponse | null = null //标题
  errormsg = '' //不为空 就实现错误页面
  choice: any[] | null = null //促销商品

  async created() {
    this.config = await getChoiceCMS()
    this.$setTitle(this.config.title)
    this.$tracker('127', '121012980')()
    this.setShare()

    this.getChoiceData()
  }

  async getChoiceData() {
    try {
      const { spuId = '' } = this.$route.query
      const params = {
        spuId: spuId as string,
      }
      this.choice = await getChoiceList(params)
      if (this.showEmpty) {
        this.errormsg = '暂无相关信息哦～'
      }
    } catch (error) {
      this.errormsg = error
    }
  }

  async setShare() {
    const shareInfo = {
      title: this.config?.title,
      desc: this.config?.shareDes,
      imgUrl: this.config?.shareImg,
    }
    setShareInfo(shareInfo)
    window.isActivePage = function () {
      return 1
    }
  }

  clicked(info: any) {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012980', clickId: '200001', positionParam: { spuid: info.spuId } })
  }

  get showEmpty() {
    if (this.choice && this.choice.length > 0) {
      return false
    }
    return true
  }
}
